<template>
    <div class="director-wrapper" :class="{'menu-open': menuOpen}">
        <div class="menu">
            <span class="menu-link" @click="menuOpen=!menuOpen"><i class="fas" :class="{'fa-bars': !menuOpen, 'fa-times': menuOpen}"></i></span>
            <router-link :to="{name: 'Welcome'}"><img class="logo" src="../../../assets/logo.png"/></router-link>

            <div class="menu-options">
                <router-link :to="{name: 'Welcome'}"><i class="fas fa-home" style="margin: 0;"></i></router-link>
                <router-link :to="{name: 'Store'}"><i class="fas fa-shopping-cart"></i> Kit Store</router-link>
                <router-link :to="{name: 'Builder'}"><i class="fas fa-toolbox"></i> Kit Builder</router-link>
                <router-link :to="{name: 'Director'}" class="active"><i class="fas fa-bullhorn"></i> Escape It Director</router-link>
                <!--<a><i class="fas fa-user"></i></a>-->
                <a @click="logout()"><i class="fas fa-power-off"></i></a>
            </div>
        </div>

            <div class="director-frame" :class="roomBackground">
                <div class="side-menu">
                    <div class="main">
                        <router-link :to="{name: 'Builder'}" class="active"><i class="fas fa-toolbox"></i> Builder</router-link>
                        <router-link :to="{name: 'Director'}"><i class="fas fa-bullhorn"></i>Director</router-link>
                        <!--<a><i class="fas fa-user"></i></a>-->
                        <a @click="logout()"><i class="fas fa-power-off"></i></a>
                    </div>
                    <div class="rooms" v-if="mode==='rooms'">
                        <header>
                            <h2><i class="far fa-door-closed"></i> Escape Rooms</h2>
                            <b-button variant="primary" class="new" @click="newRoomForm = !newRoomForm"><i class="fas fa-plus-square"></i></b-button>
                            <div class="clearfix"></div>
                        </header>
                        <ul class="room-list">
                            <li class="room" v-for="(room, index) in rooms" :key="room.id" @click="selectRoom(room)" :class="{'active': room === selectedRoom}">
                                <div class="title">{{room.title}}</div>
                                <div class="status"><i class="fas" :class="{
                                    'fa-stop': room.status === 'stopped',
                                    'fa-door-open': room.status === 'prepared',
                                    'fa-play': room.status === 'running' || room.status === 'starting',
                                    'fa-pause': room.status === 'paused',
                                    'fa-check': room.status === 'success',
                                    'fa-skull': room.status === 'failed',
                                }"></i> &nbsp;{{room.status | capitalize}}:
                                    <span v-if="room.hours !== '00'">{{room.hours}}:</span>{{room.minutes}}:{{room.seconds}}
                                </div>
                            </li>
                        </ul>

                        <div v-if="newRoomForm" class="new-room-form">
                            <h5><i class="fas fa-plus-square"></i> New Room</h5>
                            <b-form>
                                <b-select v-model="newRoom.build" :options="options">
                                    <template slot="first">
                                        <!-- this slot appears above the options from 'options' prop -->
                                        <option :value="null" disabled>Select a Kit Build</option>
                                    </template>
                                </b-select>
                                <b-form-input id="title" v-model="newRoom.title" required placeholder="Room Title"></b-form-input>

                                <div class="buttons">
                                    <b-button variant="primary" @click="create()">Create</b-button>
                                    <b-button variant="link" @click="newRoomForm=false">Cancel</b-button>
                                </div>
                            </b-form>
                        </div>
                    </div>
                    <div class="displays" v-if="mode==='displays'">
                        <div v-if="selectedRoom">
                            <header>
                                <h2><i class="far fa-tv"></i> Display Devices</h2>
                                <b-button variant="primary" class="new" @click="newDisplayForm = !newDisplayForm"><i class="fas fa-plus-square"></i></b-button>
                                <div class="clearfix"></div>
                            </header>
                            <ul class="display-list">
                                <li class="display" v-for="display in selectedRoom.displays" :key="display.id" :class="{'active': display.active}" @click="display.active=!display.active">
                                    <div class="title"><i class="fas fa-tv"></i>{{display.name}}</div>
                                </li>
                            </ul>
                            <div v-if="selectedRoom.displays.length === 0" class="error major">
                                <i class="icon far fa-exclamation-triangle"></i>
                                A display must be connected<br>for this kit. Click &nbsp;<i class="fas fa-plus-square"></i>&nbsp; above to connect a display.<br>
                                <b-button variant="link" @click="setView('help')"><i class="far fa-question-circle"></i> Need Help?</b-button>
                            </div>
                            <div v-if="newDisplayForm" class="connect-display-form">
                                <h5><i class="fas fa-plus-square"></i> Connect Display</h5>
                                <b-form>
                                    <b-form-input v-model="newDisplay.code" placeholder="Display Code"></b-form-input>
                                    <b-form-input v-model="newDisplay.title" placeholder="Display Title"></b-form-input>

                                    <div class="buttons">
                                        <b-button variant="primary" @click="connectDisplay()">Create</b-button>
                                        <b-button variant="link" @click="newDisplayForm=false">Cancel</b-button>
                                    </div>
                                </b-form>
                            </div>
                        </div>
                        <div v-else>
                            <header>
                                <h2><i class="far fa-tv"></i> Display Devices</h2>
                                <div class="clearfix"></div>
                            </header>
                            <div class="error">
                                <i class="icon far fa-door-closed"></i>
                                Choose a Room from<br>the Rooms Tab
                            </div>
                        </div>
                    </div>
                    <div class="interacts" v-if="mode==='interacts'">
                        <div v-if="selectedRoom">
                            <header>
                                <h2><i class="far fa-tablet"></i> Interact Devices</h2>
                                <div class="clearfix"></div>
                            </header>
                            <div class="error">
                                <i class="icon far fa-times-circle"></i>
                                Interact Device options are not available for this kit.
                            </div>
                        </div>
                        <div v-else>
                            <header>
                                <h2><i class="far fa-tablet"></i> Interact Devices</h2>
                                <div class="clearfix"></div>
                            </header>
                            <div class="error">
                                <i class="icon far fa-door-closed"></i>
                                Choose a Room from<br>the Rooms Tab
                            </div>
                        </div>
                    </div>
                    <div class="timer" v-if="mode==='timer'">
                        <div v-if="selectedRoom">
                            <header>
                                <h2><i class="far fa-stopwatch"></i> Room Timer</h2>
                                <div class="clearfix"></div>
                            </header>
                            <b-container>
                                <div class="help-text">
                                    Pause or resume the room timer.
                                </div>
                                <b-button variant="primary" @click="pauseTimer()" v-if="selectedRoom.status === 'running'"><i class="far fa-pause"></i> &nbsp;Pause Room</b-button>
                                <b-button variant="primary" @click="resumeTimer()" v-if="selectedRoom.status === 'paused'"><i class="far fa-play"></i> &nbsp;Resume Room</b-button>
                            </b-container>
                            <b-container>
                                <div class="help-text">
                                    Give more time or make an adjustment to the room timer by providing a new time (in minutes).
                                </div>
                                <b-form>
                                    <b-form-input v-model="selectedRoom.setTime" placeholder="Set Time in Minutes"></b-form-input>
                                    <b-button variant="primary" @click="setTimer()"><i class="far fa-stopwatch"></i> &nbsp;Set Timer</b-button>
                                </b-form>
                            </b-container>
                            <b-container>
                                <div class="help-text">
                                    A Display's timer may differ slightly from the Director. Click 'Resync Timers' to sync them up.
                                </div>
                                <b-button variant="primary" @click="syncTimers()"><i class="far fa-sync"></i> &nbsp;Resync Timers</b-button>
                            </b-container>
                        </div>
                        <div v-else>
                            <header>
                                <h2><i class="far fa-stopwatch"></i> Room Timer</h2>
                                <div class="clearfix"></div>
                            </header>
                            <div class="error">
                                <i class="icon far fa-door-closed"></i>
                                Choose a Room from<br>the Rooms Tab
                            </div>
                        </div>
                    </div>
                    <div class="menu-options">
                        <ul>
                            <li @click="setMode('rooms')" :class="{'active': mode==='rooms'}"><i class="far fa-door-closed"></i> Rooms</li>
                            <li @click="setMode('displays')" :class="{'active': mode==='displays'}"><i class="far fa-tv"></i> Displays
                                <b-badge v-if="selectedRoom" :class="{'none': selectedRoom.displays.length === 0}"><span v-if="selectedRoom.displays.length>0">{{selectedRoom.displays.length}}</span><span v-else><i class="fas fa-exclamation-triangle"></i></span></b-badge>
                            </li>
                            <li @click="setMode('interacts')" :class="{'active': mode==='interacts'}"><i class="far fa-tablet"></i> Interacts</li>
                            <li @click="setMode('timer')" :class="{'active': mode==='timer'}"><i class="far fa-stopwatch"></i> Timer</li>
                        </ul>
                    </div>
                </div>

                <div v-if="selectedRoom">
                    <div v-if="view==='direct'" class="content-frame direct">
                        <div v-if="selectedRoom.displays.length > 0">
                            <component class="director" v-if="directComponent" :is="directComponent" :room="selectedRoom" :message="message" :view="view" v-on:sound="sound" v-on:screen="screen" v-on:timer="timer" v-on:status="status"></component>
                        </div>
                        <div v-else class="display-error">
                            <i class="icon far fa-exclamation-triangle"></i>
                            A display must be connected<br>for this kit.<br>

                            <div class="tip">
                                <p>On your <u>Display Device</u> visit the site:</p>
                                <div class="url">https://app.escapeitkit.com/#/display</div>
                            </div>

                            <b-button variant="link" @click="setView('help')"><i class="far fa-question-circle"></i> Need More Help?</b-button>
                        </div>
                    </div>
                    <div v-else-if="view==='assist'" class="content-frame assist">
                        <component class="director" v-if="assistComponent" :is="assistComponent" :build="build"></component>
                    </div>
                    <div v-else-if="view==='help'" class="content-frame help">
                        <component v-if="helpComponent" :is="helpComponent" :build="build"></component>
                        <help :build="build"></help>
                    </div>

                    <div class="control">
                        <div class="room-info">
                            <div class="icon">
                                <i class="fas" :class="{
                                    'fa-stop': selectedRoom.status === 'stopped',
                                    'fa-door-open': selectedRoom.status === 'prepared',
                                    'fa-play': selectedRoom.status === 'running' || selectedRoom.status === 'starting',
                                    'fa-pause': selectedRoom.status === 'paused',
                                    'fa-check': selectedRoom.status === 'success',
                                    'fa-skull': selectedRoom.status === 'failed',
                                }"></i>
                            </div>
                            <div class="room-name">
                                <div class="title">{{selectedRoom.title}} &mdash; {{selectedRoom.status | capitalize}}</div>
                                <div class="meta">
                                <span class="remaining">
                                    <span v-if="selectedRoom.hours !== '00'">{{selectedRoom.hours}}:</span>{{selectedRoom.minutes}}:{{selectedRoom.seconds}}.{{selectedRoom.milliseconds}}
                                </span>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>

                        <div class="menu-options">
                            <ul>
                                <li @click="setView('direct')" :class="{'active': view==='direct'}"><i class="far fa-bullhorn"></i> Direct</li>
                                <li @click="setView('assist')" :class="{'active': view==='assist'}"><i class="far fa-parachute-box"></i> Assist</li>
                                <li @click="setView('help')" :class="{'active': view==='help'}"><i class="far fa-question-square"></i> Help</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div v-else class="content-frame empty">
                    <div class="full">
                        <img src="../../../assets/director_instructions_full_1.png" class="instructions-1"/>
                        <!--<img src="../../../assets/director_instructions_full_2.png" class="instructions-2"/>-->
                        <!--<img src="../../../assets/director_instructions_full_3.png" class="instructions-3"/>-->
                    </div>
                    <div class="collapsed">
                        <!--<img src="../../../assets/director_instructions_collaped_1.png" class="instructions-1"/>-->
                    </div>
                </div>

            </div>
        </div>
</template>

<script>
    import auth from '../../../services/auth';
    import rooms from '../../../services/rooms';
    import displays from '../../../services/displays';
    import Help from './help.vue';

    import Kit1Director from '../../../kits/1/director.vue';
    import Kit1Assist from '../../../kits/1/assist.vue';
    import Kit1Help from '../../../kits/1/help_director.vue';


    const MILLISECONDS_SECOND = 1000;
    const MILLISECONDS_MINUTE = 60 * MILLISECONDS_SECOND;
    const MILLISECONDS_HOUR = 60 * MILLISECONDS_MINUTE;
    const MILLISECONDS_DAY = 24 * MILLISECONDS_HOUR;

    export default {
        name: "director",
        components: {
            Help, Kit1Director, Kit1Assist, Kit1Help
        },
        mounted() {
            this.$store.commit('setNavbarVisibility', false);
        },
        destroyed() {
            this.$store.commit('setNavbarVisibility', true);
        },
        data: function () {
            return {
                menuOpen: false,
                newRoomForm: false,
                newRoom: {
                    title: '',
                    build: null
                },
                showMenu: false,
                mode: 'rooms',
                view: 'empty', // Empty state
                roomBackground: 'none',
                selectedRoom: null,
                directComponent: null,
                assistComponent: null,
                helpComponent: null,

                newDisplayForm: false,
                newDisplay: {
                    code: null,
                    title: ''
                }
            }
        },
        methods: {
            create: function () {
                rooms.createRoom(this.newRoom.title, this.newRoom.build.id).then(room => {
                    this.newRoomForm = false;
                    room.finishTime = new Date().getTime() + room.time;
                    this.rooms.push(room);
                });
            },
            setMode: function (mode) {
                this.mode = mode;
            },
            setView: function (view) {
                this.view = view;
            },
            selectRoom: function (room) {
                this.selectedRoom = room;
                this.roomBackground = 'kit' + room.kit_id;
                this.directComponent = 'kit' + room.kit_id + 'Director';
                this.assistComponent = 'kit' + room.kit_id + 'Assist';
                this.helpComponent = 'kit' + room.kit_id + 'Help';

                this.setView('direct');

                // Update room and get latest displays list
                rooms.getRoom(room.id, this.$store.state.socket.identity).then(room => {
                    this.selectedRoom.displays = room.displays;
                    this.selectedRoom.config = room.config;
                });
            },
            connectDisplay: function () {
                if (this.newDisplay.code && this.newDisplay.code.length === 4) {
                    console.log(this.selectedRoom);
                    displays.connectDisplay(this.selectedRoom.id, this.newDisplay.code, this.selectedRoom.code, this.$store.state.socket.identity).then(display_id => {
                        this.selectedRoom.displays.push({identity: display_id, name: this.newDisplay.title, active: true});
                        this.$socket.sendObj({
                            cmd: 'send',
                            data: {
                                identity: display_id,
                                message: {
                                    cmd: 'connected',
                                    data: {
                                        display_name: this.newDisplay.title,
                                        room_id: this.selectedRoom.id,
                                        kit_id: this.selectedRoom.kit_id,
                                        title: this.selectedRoom.title,
                                        code: this.selectedRoom.code,
                                        config: this.selectedRoom.config
                                    }
                                }
                            },
                            identity: this.$store.state.socket.identity
                        });

                        this.newDisplay.code = '';
                        this.newDisplay.title = '';
                        this.newDisplayForm = false;
                    }, err => {
                        window.alert(err);
                    });
                } else {
                    window.alert('Invalid Display Code.  This will be a 4 character code presented on your Display device.');
                }
            },
            disconnectDisplay: function (identity) {
                displays.disconnectDisplay(identity).then(() => {
                    this.selectedRoom.displays.splice(this.selectedRoom.displays.indexOf(identity), 1);
                });
            },
            sound: function (action, sound) {
                if (action === 'play') {
                    console.log('Play', sound);
                    sendToDisplays(this, 'play', {sound: sound});
                } else if (action === 'stop') {
                    console.log('Stop', sound);
                    sendToDisplays(this, 'stop', {sound: sound});
                }
            },
            screen: function (screen) {
                console.log('Screen Event', screen);
                sendToDisplays(this, 'screen', {screen: screen});
            },
            status: function (status) {
                console.log('Status Event', status);
                sendToDisplays(this, 'status', {status: status});
                rooms.setStatus(this.selectedRoom.id, status);
                this.selectedRoom.status = status;
            },
            timer: function (time) {
                if (time === 0) {
                    this.status('stopped');
                } else {
                    this.status('running');
                }
                this.selectedRoom.time = time;
                this.selectedRoom.finishTime = new Date().getTime() + time;
                sendToDisplays(this, 'timer', {time: time});
                rooms.setRemaining(this.selectedRoom.id, time);
            },
            setTimer: function () {
                let setToTime = parseFloat(this.selectedRoom.setTime);
                if (!isNaN(setToTime)) {
                    this.timer(setToTime * 60 * 1000);
                }
                this.selectedRoom.setTime = null;
            },
            syncTimers: function () {
                sendToDisplays(this, 'timer', {time: this.selectedRoom.time});
            },
            pauseTimer: function () {
                rooms.setRemaining(this.selectedRoom.id, this.selectedRoom.time);
                this.status('paused');
            },
            resumeTimer: function () {
                this.selectedRoom.finishTime = new Date().getTime() + this.selectedRoom.time;
                rooms.setRemaining(this.selectedRoom.id, this.selectedRoom.time);
                this.status('running');
            },
            next() {
                this.timeout = setTimeout(this.step.bind(this), 10);
            },
            step() {
                if (this.rooms) {
                    for (let i = 0; i < this.rooms.length; i++) {
                        let room = this.rooms[i];
                        if (room.status === 'running') {
                            room.time = Math.max(0, room.finishTime - new Date().getTime());

                            if (room.time <= 100) {
                                room.time = 0;
                                room.status = 'failed';
                            }
                        }

                        room.hours = pad(Math.floor((room.time % MILLISECONDS_DAY) / MILLISECONDS_HOUR), 2);
                        room.minutes = pad(Math.floor((room.time % MILLISECONDS_HOUR) / MILLISECONDS_MINUTE), 2);

                        let data = ((room.time % MILLISECONDS_MINUTE) / MILLISECONDS_SECOND).toFixed(2).split('.');
                        room.seconds = pad(data[0], 2);
                        room.milliseconds = pad(data[1], 2);
                    }
                }
                this.next();
            },
            logout() {
                auth.logout();
            }
        },

        computed: {
            options: function () {
                let options = [];
                let builds = this.$store.getters['user/builds'];
                for (let i = 0; i < builds.length; i++) {
                    let build = builds[i];
                    options.push({value: build, text: build.title});
                }
                return options;
            },
            build: function () {
                return this.newRoom.build;
            },
            message: function () {
                return this.$store.state.socket.message;
            }
        },
        asyncComputed: {
            rooms: function () {
                return rooms.getRooms().then(rooms => {
                    for (let i = 0; i < rooms.length; i++) {
                        let room = rooms[i];
                        room.finishTime = new Date().getTime() + room.time;
                    }

                    // // auto select first room
                    // if(rooms.length) this.selectRoom(rooms[0]);

                    return rooms;
                });
            }
        },
        watch: {
            build(newValue) {
                this.newRoom.title = newValue.title;
            },
            message(payload) {
                // console.log('Socket message watch from Director', payload);
                switch (payload.cmd) {
                    case 'disconnected':
                        if (this.selectedRoom && this.selectedRoom.code.toLowerCase() === payload.room) {
                            for (let i = 0; i < this.selectedRoom.displays.length; i++) {
                                if (this.selectedRoom.displays[i].identity === payload.identity)
                                    this.selectedRoom.displays.splice(i, 1);
                            }
                        }
                        break;
                    case 'connected':
                        if (this.selectedRoom && this.selectedRoom.code.toLowerCase() === payload.room) {
                            this.selectedRoom.displays.push({
                                active: true,
                                identity: payload.identity,
                                name: payload.name
                            });
                        }
                        break;
                }
            }
        },
        filters: {
            capitalize: function (value) {
                if (!value) return '';
                value = value.toString();
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },
        created: function () {
            this.next();
        }
    }

    function sendToDisplays(context, cmd, data) {
        for (let i = 0; i < context.selectedRoom.displays.length; i++) {
            if (context.selectedRoom.displays[i].active) {
                context.$socket.sendObj({
                    cmd: 'send',
                    data: {
                        identity: context.selectedRoom.displays[i].identity,
                        message: {
                            cmd: cmd,
                            data: data
                        }
                    },
                    identity: context.$store.state.socket.identity
                });
            }
        }
    }

    function pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }
</script>

<style lang="scss" scoped>
    .director-wrapper {
        font-family: "Roboto", sans-serif;

        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;

        .menu {
            margin: 0 auto;

            .logo {
                padding: 12px 0 0 10px;
                float: left;

                img {
                    max-width: 179px;
                    width: 100%;
                }

                @media (max-width: 770px) {
                    float: right;
                    margin-right: 16px;
                }
            }

            .menu-link {
                float: left;
                padding: 20px 0 0 20px;
                display: none;

                i {
                    font-size: 26px;
                }

                @media (max-width: 770px) {
                    display: inline-block;
                }
            }

            .menu-options {
                position: absolute;
                right: 0;

                a {
                    display: inline-block;
                    padding: 20px;
                    font-size: 18px;
                    color: rgba(255, 255, 255, 0.50);
                    height: 65px;

                    i {
                        font-size: 22px;
                        margin-right: 10px;
                        color: rgba(255, 255, 255, 0.50);
                    }

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.30);
                        text-decoration: none;
                    }

                    &.active {
                        box-shadow: inset 0 3px 0 #e45114;
                        background-color: rgba(16, 16, 16, 0.98);
                        color: white;
                        i {
                            color: white;
                        }

                    }
                }

                @media (max-width: 770px) {
                    display: none;
                }
            }
        }

        .director-frame {
            margin: 0 auto;
            position: absolute;
            left: 0;
            right: 0;
            top: 65px;
            bottom: 0;

            background-color: rgba(0, 0, 0, 0.7);

            &.kit1 {
                background: #111 url('../../../assets/kit_1.jpg');
                background-size: cover;
            }

            .side-menu {
                position: absolute;
                width: 300px;
                bottom: 0;
                left: 0;
                top: 0;

                background-color: rgba(0, 0, 0, 0.9);

                .main {
                    display: none;
                    background-color: rgba(255, 255, 255, 0.1);

                    a {
                        display: inline-block;
                        padding: 10px 20px 8px 20px;
                        font-size: 14px;
                        color: rgba(255, 255, 255, 0.50);

                        i {
                            font-size: 15px;
                            margin-right: 5px;
                            color: rgba(255, 255, 255, 0.50);
                        }

                        &:hover {
                            background-color: rgba(0, 0, 0, 0.30);
                            text-decoration: none;
                        }

                        &.active {
                            box-shadow: inset 0 3px 0 #e45114;
                            background-color: rgba(0, 0, 0, 0.7);
                            color: white;
                            i {
                                color: white;
                            }

                        }
                    }

                    @media (max-width: 768px) {
                        display: block;
                    }
                }

                header {
                    background-color: rgba(255, 255, 255, 0.3);
                    margin-bottom: 2px;
                    min-height: 38px;

                    h2 {
                        padding: 10px 20px 0;
                        margin: 0;
                        float: left;
                        font-size: 16px;

                        i {
                            margin-right: 6px;
                        }
                    }

                    .new {
                        float: right;
                        border-radius: 0;
                        border: none;
                        margin: 0;
                        font-size: 1.1rem;
                        border-left: 2px solid rgba(0, 0, 0, 0.6);
                    }
                }

                .menu-options {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    left: 0;

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        display: flex;
                        justify-content: space-between;

                        li {
                            flex-grow: 1;

                            text-align: center;
                            font-size: 0.7rem;
                            color: rgba(255, 255, 255, 0.50);
                            padding: 12px 5px 10px;
                            background-color: rgba(255, 255, 255, 0.15);
                            border-left: 1px solid rgba(0, 0, 0, 0.6);
                            border-right: 1px solid rgba(0, 0, 0, 0.6);
                            width: 25%;
                            position: relative;

                            i {
                                display: block;
                                font-size: 20px;
                                margin-bottom: 6px;
                                color: white;
                            }

                            span.badge {
                                position: absolute;
                                top: 0;
                                right: 0;
                                border-radius: 0;
                                padding: 3px 5px;
                                background-color: rgb(1, 122, 255);
                                font-size: 10px;
                                font-weight: bold;

                                &.none {
                                    background-color: transparent;
                                    padding: 3px 4px 0 5px;

                                    i {
                                        color: red;
                                        font-size: 11px;
                                    }
                                }
                            }

                            &:first-child {
                                border-left: 0;
                            }

                            &:last-child {
                                border-right: 2px solid rgba(0, 0, 0, 0.6);
                            }

                            &:hover {
                                background-color: rgba(255, 255, 255, 0.20);
                            }

                            &.active {
                                box-shadow: inset 0 -3px 0 #e45114;
                                color: white;
                                background-color: transparent;

                            }
                        }
                    }
                }

                .rooms {
                    .room-list {
                        list-style: none;
                        margin: 0;
                        padding: 0;

                        .room {
                            padding: 16px;
                            border-bottom: 2px solid #000;
                            cursor: pointer;
                            background-color: rgba(255, 255, 255, 0.15);
                            border-left: 3px solid transparent;

                            .status {
                                font-size: 12px;
                                color: #999;
                                margin-top: 4px;

                                i {
                                    &.fa-stop {
                                        color: red;
                                    }
                                    &.fa-door-open {
                                        color: orange;
                                    }
                                    &.fa-play {
                                        color: rgb(1, 122, 255);
                                    }
                                    &.fa-pause {
                                        color: rgb(134, 134, 134);
                                    }
                                    &.fa-check {
                                        color: rgb(4, 134, 10);
                                    }
                                    &.fa-skull {
                                        color: red;
                                    }
                                }
                            }

                            .title {
                                font-size: 15px;
                                line-height: 16px;
                            }

                            &.active {
                                border-left: 3px solid #e45114;
                                background-color: rgba(255, 255, 255, 0.1);
                            }
                        }
                    }

                    .new-room-form {
                        position: absolute;
                        top: 38px;
                        left: 0;
                        right: 0;

                        padding: 16px;
                        background-color: #017AFF;

                        h5 {
                            font-size: 16px;
                            margin-bottom: 20px;

                            i {
                                margin-right: 8px;
                            }
                        }

                        input, select {
                            margin-bottom: 10px;
                        }

                        .buttons {
                            margin-top: 20px;
                            .btn-primary {
                                background: white;
                                color: black;
                            }
                            .btn-link {
                                color: white;
                            }
                        }

                        @media (max-width: 768px) {
                            top: 77px;
                        }
                    }
                }

                .displays {
                    .connect-display-form {
                        position: absolute;
                        top: 38px;
                        left: 0;
                        right: 0;

                        padding: 16px;
                        background-color: #017AFF;

                        h5 {
                            font-size: 16px;
                            margin-bottom: 20px;

                            i {
                                margin-right: 8px;
                            }
                        }

                        input, select {
                            margin-bottom: 10px;
                        }

                        .buttons {
                            margin-top: 20px;
                            .btn-primary {
                                background: white;
                                color: black;
                            }
                            .btn-link {
                                color: white;
                            }
                        }

                        @media (max-width: 768px) {
                            top: 77px;
                        }
                    }

                    .display-list {
                        list-style: none;
                        margin: 0;
                        padding: 0;

                        .display {
                            padding: 16px;
                            border-bottom: 2px solid #000;
                            cursor: pointer;
                            background-color: rgba(255, 255, 255, 0.15);
                            border-left: 3px solid transparent;

                            .status {
                                font-size: 11px;
                                color: #999;
                                margin-top: 4px;
                            }

                            .title {
                                font-size: 14px;
                                line-height: 16px;

                                i {
                                    margin-right: 10px;
                                }
                            }

                            &.active {
                                border-left: 3px solid #e45114;
                                background-color: rgba(255, 255, 255, 0.1);
                            }
                        }
                    }
                }

                .interacts {

                }

                .timer {
                    input {
                        margin-bottom: 15px;
                    }
                }

                .help-text {
                    font-size: 13px;
                    margin: 25px 20px 15px 0;
                    display: block;
                }

                .error {
                    padding: 0 30px;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.35);

                    i.icon {
                        display: block;
                        font-size: 50px;
                        margin: 50px 0 20px;
                    }

                    button {
                        margin-top: 30px;
                        i {
                            margin-right: 6px;
                        }
                    }

                    &.major {
                        color: white;

                        i.icon {
                            color: red;
                        }
                    }
                }

                @media (max-width: 768px) {
                    display: none;
                }
            }

            .control {
                position: absolute;
                bottom: 0;
                left: 300px;
                right: 0;
                background-color: rgba(40, 40, 40, 0.9);

                min-height: 64px;

                @media (max-width: 768px) {
                    left: 0;
                }

                .room-info {
                    position: absolute;
                    left: 0;

                    .icon {
                        float: left;
                        padding: 12px 20px 0 20px;

                        i {
                            font-size: 44px;

                            &.fa-stop {
                                color: red;
                            }
                            &.fa-door-open {
                                color: orange;
                            }
                            &.fa-play {
                                color: rgb(1, 122, 255);
                            }
                            &.fa-pause {
                                color: rgb(134, 134, 134);
                            }
                            &.fa-check {
                                color: rgb(4, 134, 10);
                            }
                            &.fa-skull {
                                color: red;
                            }
                        }
                    }

                    .room-name {
                        float: left;
                        padding-top: 7px;

                        .title {
                            font-size: 12px;
                            line-height: 22px;
                        }
                        .meta {
                            font-size: 27px;
                            line-height: 27px;

                            @media (max-width: 900px) {
                                .status {
                                    display: none;
                                }
                            }
                        }
                    }
                }

                .menu-options {
                    position: absolute;
                    right: 0;
                    width: 225px;
                    height: 64px;

                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        display: flex;
                        justify-content: space-between;

                        li {
                            flex-grow: 1;

                            text-align: center;
                            font-size: 0.7rem;
                            color: rgba(255, 255, 255, 0.50);
                            padding: 12px 5px 10px;
                            /*background-color: rgba(255, 255, 255, 0.15);*/
                            border-left: 1px solid rgba(0, 0, 0, 0.6);
                            border-right: 1px solid rgba(0, 0, 0, 0.6);
                            width: 25%;
                            position: relative;

                            i {
                                display: block;
                                font-size: 20px;
                                margin-bottom: 6px;
                                color: white;
                            }

                            &:first-child {
                                border-left: 2px solid rgba(0, 0, 0, 0.6);
                            }

                            &:last-child {
                                border-right: 0;
                            }

                            &:hover {
                                background-color: rgba(255, 255, 255, 0.20);
                            }

                            &.active {
                                box-shadow: inset 0 -3px 0 #e45114;
                                color: white;
                                background-color: rgba(0, 0, 0, 0.7);

                            }
                        }
                    }
                }

                @media (max-width: 500px) {
                    .room-info {
                        position: static;
                        display: block;
                        left: auto;

                        padding: 5px 15px 5px 15px;
                        background-color: rgba(0, 0, 0, 0.7);

                        .icon {
                            padding: 10px 0 0;
                            float: right;
                            i {
                                font-size: 30px;
                            }
                        }

                        .room-name {
                            padding: 0;
                        }
                    }

                    .menu-options {
                        position: static;
                        display: block;
                        width: 100%;
                    }
                }
            }

            .content-frame {
                position: absolute;
                bottom: 64px;
                left: 300px;
                top: 0;
                right: 0;
                padding: 10px 10px 5rem 10px;

                overflow: auto;

                background-color: rgba(0, 0, 0, 0.8);

                @media (max-width: 768px) {
                    left: 0;
                }

                &.empty {
                    background: #111 url('../../../assets/dark_cartographer_bg.png');
                    bottom: 0;

                    .full {
                        .instructions-1 {
                            position: absolute;
                            top: 0;
                            left: 0;
                        }
                        .instructions-2 {
                            position: absolute;
                            top: 0;
                            right: 0;
                        }
                        .instructions-3 {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                        }

                        @media (max-width: 768px) {
                            display: none;
                        }
                    }

                    .collapsed {
                        display: none;

                        .instructions-1 {
                            position: absolute;
                            top: 0;
                            left: 0;
                        }

                        @media (max-width: 768px) {
                            display: block !important;
                        }
                    }

                }

                .display-error {

                    padding: 0 30px;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.6);

                    i.icon {
                        display: block;
                        font-size: 50px;
                        margin: 50px 0 20px;
                    }

                    button {
                        margin-top: 30px;
                        i {
                            margin-right: 6px;
                        }
                    }

                    .tip {

                        margin-top: 50px;
                        .url {
                            border: 1px solid #017BFF;
                            padding: 10px 20px;
                            font-size: 20px;
                            margin-bottom: 30px;
                            display: inline-block;
                            color: white;
                        }
                    }

                    @media (max-width: 768px) {
                        left: 0;
                    }
                }

                @media (max-width: 500px) {
                    .director {
                        bottom: 123px;
                    }
                }
            }

        }

        &.menu-open {
            .director-frame {
                .side-menu {
                    display: block;
                    z-index: 1000;
                    background: black;

                    -webkit-box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);
                    -moz-box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);
                    box-shadow: 5px 10px 50px 0 rgba(0,0,0,0.75);

                    transition: left 0.5s;

                    .menu-options ul li:last-child {
                        border-right: 0;
                    }
                }

                .control {
                    ul li {
                        display: none;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/app/director/director.vue